import React, { useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Seo from "../../components/Seo";
import "./Admin.css";

function formatErr(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return e?.message || "Login failed";
}

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user.role === "admin") {
    const next = location.state?.from || "/admin";
    return <Navigate to={next} replace />;
  }

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      const next = location.state?.from || "/admin";
      navigate(next, { replace: true });
    } catch (err) {
      setError(formatErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="admin-login" data-testid="admin-login-page">
      <Seo title="Admin Login" noIndex />
      <div className="admin-login__card">
        <h1 className="heading-2" style={{ textAlign: "center", marginBottom: 8 }}>Race377</h1>
        <p className="caption" style={{ textAlign: "center", marginBottom: 32 }}>Admin sign-in</p>
        <form onSubmit={onSubmit} className="admin-form">
          <div className="form-group">
            <label>Email</label>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
          </div>
          {error && <p style={{ color: "#ff5050", fontSize: "0.9rem" }} data-testid="admin-login-error">{error}</p>}
          <button type="submit" className="btn-primary" disabled={busy} data-testid="admin-login-submit">
            {busy ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
